export const PRODUCT_CATALOG_PATH = "/products" as const;
export const PRODUCT_PAGE_PREFIX = "/products/" as const;

export type ProductPageSlug =
  | "business-cards"
  | "rollup"
  | "stickers-roll"
  | "event-invitations"
  | "foam-boards"
  | "banners"
  | "printed-tshirts";

export type ProductPageContent = {
  slug: ProductPageSlug;
  title: string;
  eyebrow: string;
  summary: string;
  visual:
    | "sign-mockup"
    | "rollup-mockup"
    | "stickers-mockup"
    | "event-mockup"
    | "business-mockup"
    | "gift-mockup";
  bestFor: string[];
  specs: string[];
  options: string[];
  process: string[];
  enquiryPrompt: string;
};

export function productPagePath(slug: ProductPageSlug): string {
  return `${PRODUCT_PAGE_PREFIX}${slug}`;
}

export const PRODUCT_PAGES: ProductPageContent[] = [
  {
    slug: "business-cards",
    title: "כרטיסי ביקור",
    eyebrow: "דפוס עסקי",
    summary:
      "כרטיסי ביקור לעסקים, נותני שירותים וצוותים. מתאימים למיתוג נקי, השקות, תערוכות ופגישות עם לקוחות.",
    visual: "business-mockup",
    bestFor: ["עסקים קטנים", "אנשי מכירות", "קליניקות", "נותני שירות"],
    specs: ["גדלים סטנדרטיים או לפי צורך", "הדפסה צבעונית", "אפשרות לגימורים לפי זמינות", "מתאים להזמנה בכמות"],
    options: ["עיצוב גרפי חדש", "התאמה מקובץ קיים", "כמה עובדים באותו קו עיצובי", "הכנה לדפוס לאחר אישור"],
    process: ["שולחים לוגו ופרטים", "מאשרים סקיצה", "מדפיסים לפי הכמות", "מתאמים איסוף עצמי"],
    enquiryPrompt: "אשמח להצעת מחיר עבור כרטיסי ביקור.",
  },
  {
    slug: "rollup",
    title: "רולאפ",
    eyebrow: "תצוגה ושילוט",
    summary:
      "רולאפ לתערוכות, כנסים, חנויות, נקודות מכירה וקבלות פנים. פתרון נייד וברור להצגת מסר עסקי.",
    visual: "rollup-mockup",
    bestFor: ["כנסים", "חנויות", "עמדות מכירה", "ימי חשיפה"],
    specs: ["מידת רולאפ נפוצה: 85×200 ס״מ", "גרפיקה אנכית", "מתקן תצוגה נייד", "מתאים לשימוש חוזר"],
    options: ["עיצוב מלא", "התאמת קובץ מוכן", "החלפת גרפיקה קיימת", "מסר עסקי או אירועי"],
    process: ["בוחרים מסר ותוכן", "מכינים סקיצה אנכית", "מאשרים לפני הדפסה", "מקבלים רולאפ מוכן להצבה"],
    enquiryPrompt: "אשמח להצעת מחיר עבור רולאפ.",
  },
  {
    slug: "stickers-roll",
    title: "מדבקות בגליל",
    eyebrow: "מדבקות ומיתוג",
    summary:
      "מדבקות בגליל למוצרים, אריזות, אירועים ומיתוג עסקי. פתרון נוח להדבקה חוזרת בכמויות.",
    visual: "stickers-mockup",
    bestFor: ["מוצרי מדף", "אריזות", "מתנות לאירוע", "מיתוג עסקי"],
    specs: ["צורות וגדלים לפי צורך", "מתאים לכמויות", "אפשרות למדבקות לוגו", "קובץ מוכן או עיצוב אצלנו"],
    options: ["עגול / מרובע / צורני לפי מפרט", "מדבקות לוגו", "מדבקות שמות", "מדבקות לאריזות"],
    process: ["מגדירים גודל וכמות", "שולחים לוגו או עיצוב", "מאשרים סקיצה", "מדפיסים ומגלגלים לאיסוף"],
    enquiryPrompt: "אשמח להצעת מחיר עבור מדבקות בגליל.",
  },
  {
    slug: "event-invitations",
    title: "הזמנות לאירוע",
    eyebrow: "אירועים ושמחות",
    summary:
      "הזמנות מודפסות לאירועים פרטיים ועסקיים, בעיצוב שמתאים לקונספט של האירוע ולשפה שלכם.",
    visual: "event-mockup",
    bestFor: ["חתונות", "בר/בת מצווה", "ברית ובריתה", "אירועי חברה"],
    specs: ["עיצוב אישי", "הדפסה לפי כמות", "אפשרות לגרסאות שונות", "מתאים גם למיתוג אירוע שלם"],
    options: ["עיצוב הזמנה", "התאמה לקונספט קיים", "שפה גרפית לאירוע", "הכנה להדפסה לאחר אישור"],
    process: ["מספרים על האירוע", "בוחרים סגנון", "מאשרים סקיצה", "מדפיסים ומכינים למסירה"],
    enquiryPrompt: "אשמח להצעת מחיר עבור הזמנות לאירוע.",
  },
  {
    slug: "foam-boards",
    title: "קאפה וקירות צילום",
    eyebrow: "אירועים ותצוגה",
    summary:
      "לוחות קאפה וקירות צילום מודפסים לפי מידה, בצורה ישרה, מעוגלת או צורנית, לאירועים, חנויות ומוסדות.",
    visual: "event-mockup",
    bestFor: ["קירות צילום", "ימי הולדת", "בתי ספר", "תצוגות בחנות"],
    specs: ["מידות לפי צורך", "הדפסה ישירה על קאפה", "אפשרות לחיתוך צורני", "מתאים לקירות ולשלטי פנים"],
    options: ["מלבן ישר", "חלק עליון מעוגל", "עיגול", "עיצוב מלא או קובץ מוכן"],
    process: ["מגדירים מידה וצורה", "שולחים קובץ או בקשת עיצוב", "מאשרים סקיצה", "מדפיסים וחותכים לפי המפרט"],
    enquiryPrompt: "אשמח להצעת מחיר עבור קאפה או קיר צילום.",
  },
  {
    slug: "banners",
    title: "שמשוניות",
    eyebrow: "שילוט בפורמט גדול",
    summary:
      "שמשוניות מודפסות לפי מידה לעסקים, מוסדות, אירועים ושילוט חוץ, עם אפשרויות גימור ותלייה לפי הצורך.",
    visual: "sign-mockup",
    bestFor: ["שילוט חוץ", "אירועי חברה", "בתי ספר", "פתיחת עסקים"],
    specs: ["הדפסה צבעונית בפורמט גדול", "מידה לפי צורך", "מתאים לפנים ולחוץ", "אפשרות לטבעות או שרוולים"],
    options: ["טבעות היקפיות", "שרוול להשחלה", "ללא גימור תלייה", "עיצוב חדש או התאמת קובץ"],
    process: ["מגדירים מידה וכמות", "בוחרים גימור", "מאשרים את הגרפיקה", "מדפיסים ומכינים למסירה"],
    enquiryPrompt: "אשמח להצעת מחיר עבור שמשונית.",
  },
  {
    slug: "printed-tshirts",
    title: "חולצות מודפסות",
    eyebrow: "מתנות ממותגות",
    summary:
      "חולצות מודפסות לאירועים, צוותים, עסקים וקבוצות. מתאים למיתוג, מתנות, ימי גיבוש והפקות.",
    visual: "gift-mockup",
    bestFor: ["צוותים", "ימי גיבוש", "אירועים", "מתנות ממותגות"],
    specs: ["הדפסה לפי קובץ או עיצוב", "כמויות לפי הזמנה", "מיתוג קדמי או אחורי", "התאמה לפי צורך"],
    options: ["לוגו קטן", "הדפסה גדולה", "משפט / שם / תאריך", "עיצוב לפי קונספט"],
    process: ["שולחים מידות וכמות", "מגדירים מיקום הדפסה", "מאשרים הדמיה", "מכינים לאיסוף עצמי"],
    enquiryPrompt: "אשמח להצעת מחיר עבור חולצות מודפסות.",
  },
];

export function findProductPage(slug: string): ProductPageContent | null {
  return PRODUCT_PAGES.find((product) => product.slug === slug) ?? null;
}
